/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Musical_InstrumentsInputs */

const en_listing_category_musical_instruments = /** @type {(inputs: Listing_Category_Musical_InstrumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musical Instruments`)
};

const es_listing_category_musical_instruments = /** @type {(inputs: Listing_Category_Musical_InstrumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrumentos musicales`)
};

const fr_listing_category_musical_instruments = /** @type {(inputs: Listing_Category_Musical_InstrumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruments de musique`)
};

const de_listing_category_musical_instruments = /** @type {(inputs: Listing_Category_Musical_InstrumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musikinstrumente`)
};

const ja_listing_category_musical_instruments = /** @type {(inputs: Listing_Category_Musical_InstrumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`楽器`)
};

const zh_listing_category_musical_instruments = /** @type {(inputs: Listing_Category_Musical_InstrumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`乐器`)
};

const ar_listing_category_musical_instruments = /** @type {(inputs: Listing_Category_Musical_InstrumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آلات موسيقية`)
};

const id_listing_category_musical_instruments = /** @type {(inputs: Listing_Category_Musical_InstrumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alat Musik`)
};

const it_listing_category_musical_instruments = /** @type {(inputs: Listing_Category_Musical_InstrumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti Musicali`)
};

const ru_listing_category_musical_instruments = /** @type {(inputs: Listing_Category_Musical_InstrumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Музыкальные инструменты`)
};

const pt_listing_category_musical_instruments = /** @type {(inputs: Listing_Category_Musical_InstrumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrumentos Musicais`)
};

const ko_listing_category_musical_instruments = /** @type {(inputs: Listing_Category_Musical_InstrumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`악기`)
};

/**
* | output |
* | --- |
* | "Musical Instruments" |
*
* @param {Listing_Category_Musical_InstrumentsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_musical_instruments = /** @type {((inputs?: Listing_Category_Musical_InstrumentsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Musical_InstrumentsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_musical_instruments(inputs)
	if (locale === "es") return es_listing_category_musical_instruments(inputs)
	if (locale === "fr") return fr_listing_category_musical_instruments(inputs)
	if (locale === "de") return de_listing_category_musical_instruments(inputs)
	if (locale === "ja") return ja_listing_category_musical_instruments(inputs)
	if (locale === "zh") return zh_listing_category_musical_instruments(inputs)
	if (locale === "ar") return ar_listing_category_musical_instruments(inputs)
	if (locale === "id") return id_listing_category_musical_instruments(inputs)
	if (locale === "it") return it_listing_category_musical_instruments(inputs)
	if (locale === "ru") return ru_listing_category_musical_instruments(inputs)
	if (locale === "pt") return pt_listing_category_musical_instruments(inputs)
	return ko_listing_category_musical_instruments(inputs)
});